<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-11-29 14:30:33
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2021-11-30 11:39:34
-->
<template>
  <div class="content">
    <el-table :data="orders" style="width: 100%">
      <el-table-column label="序号" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="workTypeName"
        label="作业类型"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="orderTime"
        label="作业时间要求"
        min-width="18%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="orderUnitPrice"
        label="作业单价（元/亩）"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="trueWorkArea"
        label="作业亩数（亩）"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="workTimeBegin"
        label="作业开始时间"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="workTimeEnd"
        label="作业结束时间"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column label="作业进度" min-width="10%" align="center">
        <template slot-scope="scope">{{
          scope.row.workProgress | formatWorkProgress
        }}</template>
      </el-table-column>
      <el-table-column
        prop="statusName"
        label="状态"
        min-width="10%"
        align="center"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "OrderCompletion",
  data() {
    return {
      orders: [],
    };
  },
  props: {
    orderId: {
      type: String,
    },
  },
  filters: {
    formatWorkProgress(value) {
      return `${value}%`;
    },
  },
  created() {
    this.getWorkTypeList();
  },
  methods: {
    /**
     * @descripttion: 获取订单完成情况数据
     * @Author: juanjuanhui
     * @Date: 2021-11-23 14:04:06
     * @param {*}
     * @return {*}
     */
    getWorkTypeList() {
      let params = { orderId: this.orderId };
      this.$http.order.getWorkTypeList(params).then((res) => {
        this.orders = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  border: 1px solid #dfe7eb;
  border-bottom: none;
  .el-button {
    padding: 5px 12px;
  }
}
</style>
